import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tippy";

import InfoIcon from "../../../Common/components/Icons/Info/InfoIcon";
import AddIcon from "../../../Common/components/Icons/Add/AddIcon";

const ProductDetails = ({ num, title, color, image, info, onAdd, horizontal, options, onChange, ...props }) => {
  // console.log(options);
  return (
    <div className={`flex flex-${horizontal ? "row" : "col"} items-center  `}>
      <div className={`inline-block  ${info ? "relative" : ""}`}>
        <img src={image} alt="" className="w-32" />
        {info && (
          <div className="absolute top-0 right-0 has-tooltip-info">
            <Tooltip title={info} duration={200} arrow size="small" theme="light">
              <button
                type="button"
                className="flex flex-col items-center justify-center w-5 h-5 rounded-full
                           text-blue-400"
              >
                <InfoIcon color="#42B4E6" size={15} />
              </button>
            </Tooltip>
          </div>
        )}
      </div>
      <div className="flex flex-row gap-2 items-center w-40">
        {num && <span className="text-center text-lg font-normal leading-normal">{num}</span>}
        {options && (
          <select
            onChange={onChange}
            className="border-[1px] border-gray-400 w-fit h-fit font-normal text-base text-center"
            defaultValue={options.find((option) => option.selected)?.value}
          >
            {options.map((option) => (
              <option key={option.value}>{option.value}</option>
            ))}
          </select>
        )}
        <span className={`"text-start text-sm font-normal leading-normal  ${color ? `text-[${color}]` : ""} "`}>
          {title}
        </span>
        {props.children}
        {onAdd && (
          <button
            type="button"
            className="flex flex-col items-center justify-center w-5 h-5 rounded-full bg-[#42B4E6]"
            onClick={onAdd || undefined}
          >
            <AddIcon size="10" color="white" />
          </button>
        )}
      </div>
    </div>
  );
};

ProductDetails.propTypes = {
  num: PropTypes.number,
  title: PropTypes.string,
  color: PropTypes.string,
  image: PropTypes.string,
  info: PropTypes.string,
  onAdd: PropTypes.func,
  horizontal: PropTypes.bool,
  options: PropTypes.array,
  children: PropTypes.node,
  onChange: PropTypes.func
};

ProductDetails.defaultProps = {
  num: null,
  title: "",
  color: null,
  image: "",
  info: null,
  onAdd: null,
  horizontal: false,
  options: null,
  children: null,
  onChange: null
};

export default ProductDetails;
